{
  "error": "Error",
  "loading": "Loading",
  "newUser": "New user",
  "newUserGroup": "New group"
}
